

























import Vue, { PropType } from "vue";

// Vue Components
import PredictedMachineStatusCard from "./PredictedMachineStatusCard.vue";

// Model
import VFaIcon from "@/components/VFaIcon.vue";
import { InstallationPredictedStatus } from "@/model/data/predictiveMaintenance/InstallationPredictedStatus";
import { FetchInstallationsPredictedStatusResponse } from "@/model/communication/predictiveMaintenance/FetchInstallationsPredictedStatusResponse";
import { FetchInstallationsPredictedStatusCommand, GetDevicesPredictedStatusReqData } from "@/model/communication/predictiveMaintenance/FetchInstallationsPredictedStatusCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { Machine } from "@/model/data/Machine";

export default Vue.extend({
    components: {
        VFaIcon,
        PredictedMachineStatusCard,
    },
    data() {
        return {
            predictedStatusMachines: null,
        };
    },
    props: {
        installation: Object as PropType<InstallationPredictedStatus>,
        loading: Boolean,
    },
    computed: {
        colsAttribute(): number {
            let totalCardNumber = this.machines.length;
            if (this.$vuetify.breakpoint.mdAndDown) return 12;
            else if (totalCardNumber == 1) return 8;
            else return 6;
        },
        machines(): Machine[] {
            if (this.installation && this.installation.machines) return this.installation.machines.filter((m) => m.model != "DropVault");
            return [];
        },
    },
    watch: {
        installation() {
            this.reload();
        },
    },
    created() {
        this.reload();
    },
    methods: {
        reload() {
            this.predictedStatusMachines = this.installation.predictedMachineStatus;
        },
        async sendRequest() {
            try {
                let request = new GetDevicesPredictedStatusReqData();
                request.installationNames = [this.installation.name];
                this.loading = true;
                let response: FetchInstallationsPredictedStatusResponse = await new FetchInstallationsPredictedStatusCommand(request).execute();
                this.loading = false;
                if (response.responseStatus == ApiResponseStatusEnum.Success && response.installationsList && response.installationsList.length == 1) {
                    this.predictedStatusMachines = response.installationsList[0].predictedMachineStatus;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationsPredictedStatusCommand request ", e);
                this.loading = false;
            }
        },
        getInstallationFirstPrediction(serialNumber) {
            if (this.installation && this.installation.firstPredictionDateTime && this.installation.firstPredictionDateTime.has(serialNumber))
                return this.installation.firstPredictionDateTime.get(serialNumber);
            return "";
        },
    },
});
